<template lang="html">
<!-- eslint-disable -->
  <div class="unsecured-layout layout">
    <div v-if="!fullScreen" class="left-area">
    </div>
    <div class="content-area" :class="{ ['full-screen']: fullScreen }">
      <div v-if="!hideLogo" class="logo">
        <company-logo v-if="getUrl" :domain="getUrl" view="login"/>
        <cynergy-logo class="img-logo" v-else/>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions } from 'vuex';
import { views } from '@/router/constants';
import CompanyLogo from '@/components/common/CompanyLogo.vue';
import CynergyLogo from '@/assets/icons/whitelabeling/cynergy.app/cynergy-logo-black.svg?inline'

export default {
  name: 'UnsecuredLayout',
  components: { CompanyLogo, CynergyLogo },
  created() {
    this.resetTheme();
  },
  methods: {
    ...mapActions('theme', ['resetTheme']),
  },
  computed: {
    fullScreen() {
      return this.$route.meta.fullScreen;
    },
    hideLogo() {
      return (
        this.$route?.name === views.WORKSPACE_INFO ||
        this.$route?.name === views.CLIENT_INFO ||
        this.$route?.name === views.REGISTRATION_FINISHED ||
        this.$route?.name === views.EMAIL_VERIFICATION ||
        this.$route?.name === views.SP_FREELANCER_CLIENT_INFO ||
        this.$route?.name === views.COMPANY_SERVICES ||
        this.$route?.name === views.COMPANY_CERTIFICATION ||
        this.$route?.name === views.SP_FREELANCER_REGISTRATION_FINISHED ||
        this.$route?.name === views.COMPANY_INFO ||
        this.$route?.name === views.COMPANY_SERVICES_SP ||
        this.$route?.name === views.COMPANY_CERTIFICATIONS_SP ||
        this.$route?.name === views.EMAIL_VERIFICATION_SP ||
        this.$route?.name === views.SP_COMPANY_REGISTRATION_FINISHED);
    },
    getUrl() {
      const url = window.location.href;
      if (url.includes('localhost')) {
        return null;
      }
      const protocol = url?.split('://')[0];
      const domain = url?.split('://')[1].split('/')[0];
      return `${protocol}://${domain}`;
    },
  },
};
</script>

<style lang="scss" scoped>
/* eslint-disable */
@import '~@/assets/styles/design-system';

.unsecured-layout {
  display: flex;
  flex-direction: row;
  background: url('../../assets/background.svg') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.left-area {
  flex: 0.8;
  position: relative;
}

.content-area {
  flex: 1;
  max-width: rem(640);
  display: flex;
  flex-direction: column;

  .logo {
    height: rem(100);
    margin-top: $space-10;
    margin-bottom: $space-5;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .img-logo {
    width: inherit;
    height: rem(90);
    display: block;
    margin: auto;
  }
}

.full-screen {
  max-width: none;
}
</style>
